<svg width="24" height="25" viewBox="0 0 24 25" fill="current" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M21.3 3.4998H17.7V7.0998H21.3V3.4998ZM16.5 2.2998V8.2998H22.5V2.2998H16.5Z" fill="current"/>
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M4.5 14.3C5.49411 14.3 6.3 13.4941 6.3 12.5C6.3 11.5059 5.49411 10.7 4.5 10.7C3.50589 10.7 2.7 11.5059 2.7 12.5C2.7 13.4941 3.50589 14.3 4.5 14.3ZM4.5 15.5C6.15685 15.5 7.5 14.1569 7.5 12.5C7.5 10.8431 6.15685 9.5 4.5 9.5C2.84315 9.5 1.5 10.8431 1.5 12.5C1.5 14.1569 2.84315 15.5 4.5 15.5Z"
          fill="current"/>
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M13.2507 11.9L11.875 10.5243L12.7235 9.67578L15.5477 12.5L12.7235 15.3243L11.875 14.4758L13.2507 13.1H8.69922V11.9H13.2507Z"
          fill="current"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M21.3 10.7H17.7V14.3H21.3V10.7ZM16.5 9.5V15.5H22.5V9.5H16.5Z"
          fill="current"/>
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M21.3 17.9002H17.7V21.5002H21.3V17.9002ZM16.5 16.7002V22.7002H22.5V16.7002H16.5Z" fill="current"/>
</svg>
